import React from "react";
import { AlertTriangle, Clock, CheckCircle2, XCircle, Pause, Ban, Sparkles } from "lucide-react";

export function ClinicStatusBadge({ status, trial, trialDays }) {
  const s = (status || "active").toLowerCase();
  const map = {
    active: { bg: "bg-green-50", text: "text-green-700", border: "border-green-200", icon: <CheckCircle2 className="w-3 h-3" />, label: "Active" },
    trial: { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200", icon: <Sparkles className="w-3 h-3" />, label: "Trial" },
    suspended: { bg: "bg-orange-50", text: "text-orange-700", border: "border-orange-200", icon: <Pause className="w-3 h-3" />, label: "Suspended" },
    disabled: { bg: "bg-red-50", text: "text-red-700", border: "border-red-200", icon: <Ban className="w-3 h-3" />, label: "Disabled" },
    cancelled: { bg: "bg-slate-100", text: "text-slate-600", border: "border-slate-200", icon: <XCircle className="w-3 h-3" />, label: "Cancelled" },
    expired: { bg: "bg-slate-100", text: "text-slate-600", border: "border-slate-200", icon: <XCircle className="w-3 h-3" />, label: "Expired" },
    deleted: { bg: "bg-slate-200", text: "text-slate-700", border: "border-slate-300", icon: <XCircle className="w-3 h-3" />, label: "Deleted" },
  };
  let key = s;
  if (trial && s === "active") key = "trial";
  if (s === "trial") key = "trial";
  const m = map[key] || map.active;
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider rounded-full px-2.5 py-1 border ${m.bg} ${m.text} ${m.border}`}
      data-testid={`clinic-status-${key}`}>
      {m.icon}{m.label}
      {trial && typeof trialDays === "number" && trialDays >= 0 && (
        <span className="ml-1 font-mono">{trialDays}d</span>
      )}
    </span>
  );
}

export function RenewalBadge({ days, isTrial }) {
  if (days === null || days === undefined) {
    return <span className="text-[10px] text-slate-400">—</span>;
  }
  let color = "bg-slate-50 text-slate-600 border-slate-200";
  let label = `Renews in ${days}d`;
  let icon = <Clock className="w-3 h-3" />;
  if (days < 0) { color = "bg-red-50 text-red-700 border-red-200"; label = `Overdue ${Math.abs(days)}d`; icon = <AlertTriangle className="w-3 h-3" />; }
  else if (days <= 3) { color = "bg-red-50 text-red-700 border-red-200"; label = `Due in ${days}d`; }
  else if (days <= 7) { color = "bg-amber-50 text-amber-700 border-amber-200"; label = `Due in ${days}d`; }
  else if (days <= 15) { color = "bg-yellow-50 text-yellow-700 border-yellow-200"; }
  if (isTrial) { label = `Trial • ${days}d left`; color = "bg-amber-50 text-amber-700 border-amber-200"; icon = <Sparkles className="w-3 h-3" />; }
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider rounded-full px-2.5 py-1 border ${color}`}
      data-testid="renewal-badge">
      {icon}{label}
    </span>
  );
}

export function PaymentStatusBadge({ status }) {
  if (!status) return <span className="text-[10px] text-slate-400">—</span>;
  const m = {
    paid: "bg-green-50 text-green-700 border-green-200",
    pending: "bg-yellow-50 text-yellow-700 border-yellow-200",
    overdue: "bg-red-50 text-red-700 border-red-200",
    trial: "bg-amber-50 text-amber-700 border-amber-200",
    failed: "bg-red-50 text-red-700 border-red-200",
  }[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span className={`inline-flex items-center text-[10px] font-bold uppercase tracking-wider rounded-full px-2 py-0.5 border ${m}`}
      data-testid={`payment-status-${status}`}>{status}</span>
  );
}
